import React from 'react';
import { FaChevronUp, FaChevronDown, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
/**
 * ChevronButtonWithText is a button that has a chevron icon and customisable text
 * @param {string} chevronDirection Options being up, down, left or right
 * @param {string} text The text you want to appear within the button
 * @param {function} onClick The function to execute on button click
 * @returns
 */
const ChevronButtonWithText = _ref => {
  let {
    chevronDirection,
    text,
    onClick,
    url = "#"
  } = _ref;
  const getChevron = direction => {
    switch (direction) {
      case 'up':
        {
          return /*#__PURE__*/React.createElement(FaChevronUp, {
            "data-testid": "chevron-up",
            className: "ml-3",
            size: 32
          });
        }
      case 'down':
        {
          return /*#__PURE__*/React.createElement(FaChevronDown, {
            "data-testid": "chevron-down",
            className: "ml-3",
            size: 32
          });
        }
      case 'left':
        {
          return /*#__PURE__*/React.createElement(FaChevronLeft, {
            "data-testid": "chevron-left",
            className: "ml-3",
            size: 32
          });
        }
      case 'right':
        {
          return /*#__PURE__*/React.createElement(FaChevronRight, {
            "data-testid": "chevron-right",
            className: "ml-3",
            size: 32
          });
        }
      default:
        {
          return null;
        }
    }
  };
  const chevron = getChevron(chevronDirection);
  const handleClick = event => {
    event.preventDefault();
    onClick(event);
  };
  return /*#__PURE__*/React.createElement("a", {
    "data-testid": "chevron-button-with-text",
    onClick: handleClick,
    className: "chevron-button-with-text",
    href: url
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-0"
  }, /*#__PURE__*/React.createElement("p", {
    className: "m-0 my-auto"
  }, text, chevron)));
};
export { ChevronButtonWithText };